<template>
  <div class="spnod-admin__form--container container pl-0 mx-0 d-flex flex-column">
    <div class="d-flex flex-column">
      <b-button
        class="spnod-admin__form--button mb-2"
        size="sm"
        :href="'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)"
        target="_blank"
        :download="title">
        Download Template CSV
      </b-button>
      <b-form-file
        class="mb-3"
        size="sm"
        type="file"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
        accept=".csv"
        ref="fileInput"
        @change.prevent="handleUpload"
        multiple>
      </b-form-file>
      <div class="mb-2">
        <p class="mb-2">File must be in CSV format</p>
        <p class="mb-2">Required fields:</p>
        <ul class="pl-4">
          <li class="small mb-1">First Name</li>
          <li class="small mb-1">Last Name</li>
          <li class="small mb-1">Phone Number</li>
          <li class="small mb-1">Email</li>
        </ul>
      </div>
      <p class="mb-4">Minors will require parent consent!</p>
      <div class="mb-5">
        <p class="mb-2">Uploaded Files:</p>
        <ul class="pl-1">
          <li class="spnod-admin__form--list small mb-1 d-flex" v-for="(file, index) in files">
          <p class="pr-2">{{file.name}}</p>
          <button
            class="text-danger font-weidth-bold"
            @click="handleRemove(index)">x</button>
          </li>
        </ul>
      </div>
      <b-form-group>
        <b-button
          class="spnod-admin__form--button"
          size="sm"
          :disabled="disableReview"
          @click="handleReview">
          <p v-if="!isProcessing">Review Upload</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
        <router-link to="/group/users">
          <b-button size="sm" class="spnod-admin__form--button">Skip</b-button>
        </router-link>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BulkUploadForm',
  data() {
    return {
      csv: 'First Name,Last Name,DOB (mm/dd/yyyy),Email,Phone\n',
      files: [],
      isProcessing: false
    }
  },
  computed: {
    disableReview() {
      return !this.files.length > 0
    },
    title() {
      const randNum = Math.floor(Math.random() * (1000 - 0))
      return `SpNOD_Bulk_Upload_${randNum}.csv`
    }
  },
  mounted() {
    this.resetUsers()
  },
  methods: {
    ...mapActions(['parseCSV', 'resetUsers']),
    handleUpload(event) {
      let eventData
      // Data obj comes in diff based on event type
      if (event.type === 'drop') {
        eventData = event.dataTransfer.files
      } else {
        eventData = event.target.files
      }
      // Only store unique csv files
      for (let i = 0; i < eventData.length; i++) {
        if (this.files.every(f => f.name !== eventData[i].name)) {
          if (eventData[i].name.slice(-4).toLowerCase() === '.csv') {
            this.files.push(eventData[i])
          }
        }
      }
    },
    handleRemove(index) {
      this.files.splice(index, 1)
    },
    handleReview: async function() {
      const formData = new FormData()
      for (let i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
      }
      this.isProcessing = true
      await this.parseCSV(formData)
      this.$router.push('/bulk/review')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/BulkUploadForm.vue?a26d140c